import { InputProps } from '@cast/design-system';

export const options = [
  '--',
  'Week',
  'Day',
  'Hour',
  'Minute',
  'Month',
] as const;

export const weekDays = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
] as const;

export type Option = (typeof options)[number];
export type Constraints = { inputProps: InputProps; formState: FormState };
export type Weekday = (typeof weekDays)[number];

export type WeekState = {
  type: 'Week';
  repeatEvery: 1;
  on: Weekday[];
  at: string;
};
export type DayState = { type: 'Day'; repeatEvery: number; at: string };
export type HourState = {
  type: 'Hour';
  repeatEvery: number;
  startAtMinute: string;
};
export type MinuteState = {
  type: 'Minute';
  repeatEvery: number;
  startAt: string;
};
export type MonthState = {
  type: 'Month';
  repeatEvery: number;
  onDay: string[];
  at: string;
};

export type ValidFormState =
  | WeekState
  | MonthState
  | DayState
  | HourState
  | MinuteState;

type InvalidState = {
  type: '--';
  repeatEvery: null;
};

export type FormState =
  | WeekState
  | DayState
  | HourState
  | MinuteState
  | MonthState
  | InvalidState;

export type StandardInputsState<T extends FormState = FormState> = {
  state: T;
  setState: (setState: (state: T) => T) => void;
  isView: boolean;
};
